import React, { useEffect, useState } from "react";
import ThubBanner from "./template-parts/ThubBanner";
import styles from "../../../styles/Poll.module.scss";
import { Accordion, Button, Col, Container, Image, Row } from "react-bootstrap";
import SudokuBg from "../../../images/sudoku-bg.png";
import { Link } from "react-router-dom";
import {
  getAvailablePolls,
  getAvailableSurvey,
  getCompletedPolls,
  getCompletedSurvey,
} from "../../../store/thubMethods";
import { useDispatch, useSelector } from "react-redux";
import CompletedSurvey from "./template-parts/CompletedSurvey";
import SurveyBox from "./template-parts/SurveyBox";
import PollsBox from "./template-parts/PollsBox";
import CompletedPolls from "./template-parts/CompletedPolls";

const Poll = () => {
  const [activeTile, setActiveTile] = useState("available");
  const [currentQuest, setCurrentQuest] = useState(0);
  const completedPolls = useSelector((state) => state.thub.completedPolls);
  const availablePolls = useSelector((state) => state.thub.availablePolls);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCompletedPolls());
    dispatch(getAvailablePolls());
  }, []);
  // console.log(availablePolls);
  return (
    <div className={styles.mainCont}>
      <ThubBanner
        mainTitle={"Polls"}
        // subTitle={"Welcome to THE POLLS"}
      />

      <div className={styles.surveyCont}>
        <Container>
          <div className="d-flex justify-content-between mb-5 mt-3">
            <div>
              <span
                className={`${styles.surveyTile} ${
                  activeTile === "available" && "activeSurvey"
                }`}
                onClick={() => setActiveTile("available")}
              >
                Available
              </span>
              <span
                className={`${styles.surveyTile} ${
                  activeTile === "completed" && "activeSurvey"
                }`}
                onClick={() => setActiveTile("completed")}
              >
                Completed
              </span>
            </div>
            {/* <div>PROCESS 06/10</div> */}
          </div>
          <Row>
            {activeTile === "available" && (
              <Col md={7}>
                {!availablePolls.length ? (
                  <h6 className="text-center mt-5">
                    No active polls available
                  </h6>
                ) : (
                  ""
                )}
                {availablePolls.length ? (
                  <p className="text-start">
                    Let us know you better through the poll
                    <br /> Ready, steady, go!
                  </p>
                ) : (
                  ""
                )}
                <div className="surveyAccordian">
                  <Accordion defaultActiveKey={0} className="mb-2">
                    {availablePolls &&
                      availablePolls.map((item, i) => (
                        <Accordion.Item eventKey={i} key={i}>
                          <Accordion.Header onClick={() => setCurrentQuest(0)}>
                            {item.name}
                          </Accordion.Header>
                          <Accordion.Body>
                            <PollsBox
                              data={item.questions}
                              setCurrentQuest={setCurrentQuest}
                              currentQuest={currentQuest}
                              index={i}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                  </Accordion>{" "}
                </div>
              </Col>
            )}
            {activeTile === "completed" && (
              <Col md={7} className="surveyAccordian">
                <CompletedPolls completedPolls={completedPolls} />
              </Col>
            )}
          </Row>
        </Container>{" "}
      </div>
    </div>
  );
};

export default Poll;
